import debounce from 'lodash/debounce';
import delay from 'lodash/delay';

/**
 * Sets the padding top of the body according
 * to the amount of pixels given
 * @param  {number} amount Amount of pixels
 */
export const setBodyPadding = (amount) => {
  $('body').css('padding-top', `${amount}px`);
};
/**
 * Sets an element sticky relative to the
 * current scroll position
 *
 * Can be forced with the second parameter
 *
 * @param  {Object} $el jQuery element
 * @param  {Boolean} isSticky boolean
 */
export const toggleSticky = ($el, isSticky) => {
  const makeSticky = isSticky !== undefined ? isSticky : $(window).scrollTop() >= 100;
  $el.toggleClass('sticky', makeSticky);
};

/**
 * The stick nav directive
 */
export const stickyNav = {
  /**
   * Attaches the scroll event with the setsticky callback
   * Attaches the resize event with the setBodyPadding callback
   * @param  {element} el
   */
  bind: (el) => {
    const $el = $(el);

    // Create a debounced sticky with a 20 ms delay
    const debouncedToggleSticky = debounce(toggleSticky, 20);
    const debouncedSetBodyPadding = debounce(setBodyPadding, 20);

    $(window).scroll(() => {
      debouncedToggleSticky($el);
    });

    $(window).resize(() => {
      debouncedSetBodyPadding($el.outerHeight());
    });

    // Show 'jump-to-content' block on TAB click
    $(window).on('keydown', (e) => {
      const tabСode = 9;

      if (tabСode === e.keyCode) {
        $el.find('.jump-to-content').addClass('is-visible');
      }
    });

    // Scroll to the page content
    $el.find('.jump-to-content a').on('click', () => {
      $el.find('.jump-to-content').hide();
      $el.addClass('affix sticky');
      $(document).scrollTop($el.height());
    });

    // Set padding top and body padding on init
    delay(() => {
      debouncedSetBodyPadding($el.outerHeight());
      toggleSticky($el);
    }, 10);
  },
};
/* german-sticky banner*/
jQuery(function () {
  function sticky_relocate() {
    var isArticleExists =
      $('.article-page-wrapper .popular-item-container').length > 0 ? true : false;
    if ($(window).width() > 1023) {
      var isProductExists = $('.article-page-wrapper .related-product').length > 0 ? true : false;
      if (isProductExists) {
        isArticleExists && $('.popular-item-container').css('display', 'none');
        var window_top = $(window).scrollTop();
        var footer_top =
          $('.mixamag-bg-container').length > 0
            ? $('.mixamag-bg-container').offset().top
            : $('footer').offset().top;
        var div_top = $('.container .block-label-new').offset().top;
        var div_height = $(
          '.article-page-wrapper .article-product-short-details-container',
        ).height();
        //var div_width = $('.article-product-short-details-container').parents('.col-md-4').width()-68;

        var padding = 20; // tweak here or get from margins etc

        if (window_top + div_height + 280 > footer_top - padding)
          $('.article-page-wrapper .article-product-short-details-container').css({
            top: (window_top + div_height - footer_top + padding + 280) * -1,
          });
        else if (window_top > div_top) {
          var isclassExists = $('.stick').length > 0 ? true : false;
          if (!isclassExists) {
            $('.article-page-wrapper .article-product-short-details-container').addClass('stick');
            var stickywidth = $('.article-page-wrapper .col-md-8').width() / 2 - 40;
            $('.stick').css('width', stickywidth + 'px');
          }
          //$('.article-page-wrapper .article-product-short-details-container').removeAttr('style');
        } else {
          $('.article-page-wrapper .article-product-short-details-container')
            .removeClass('stick')
            .removeAttr('style');
          //$('.article-page-wrapper .article-product-short-details-container').css('width','auto');
        }
      }
    } else {
      isArticleExists && $('.article-page-wrapper .popular-item-container').css('display', 'block');
      $('.article-page-wrapper .article-product-short-details-container')
        .removeClass('stick')
        .removeAttr('style');
    }
  }
  if ($('html').attr('lang') === 'de') {
    $(window).on('scroll resize', function () {
      sticky_relocate();
    });
    sticky_relocate();
  }
});
